import React, { useState, useEffect } from 'react'
import { Row, Col, ButtonGroup, IconButton, Icon, Table, Uploader, Message } from 'rsuite'
import { isRequiredFiled, isValidFileType } from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import { budgetFormat, numberThousandSeparator } from '../../utils/formatterUtil'

export default function PeriodBudgetTable({ data, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  const [datas, setDatas] = useState(data || [])

  // useEffect(() => {
  //   setDatas(schema.values || [])
  // }, [schema])

  return (
    <>
      {datas && (
        <Table
          height={400}
          autoHeight={datas?.length <= 5}
          wordWrap
          bordered
          data={datas}
          style={{ marginBottom: 10 }}
        >
          <Column width={95} align="center">
            <HeaderCell>งวดที่</HeaderCell>
            <Cell dataKey="period" />
          </Column>
          <Column width={130} align="center">
            <HeaderCell>วันที่เริ่มต้น</HeaderCell>
            <Cell dataKey="startDate" />
          </Column>
          <Column width={130} align="center">
            <HeaderCell>วันที่สิ้นสุด</HeaderCell>
            <Cell dataKey="endDate" />
          </Column>
          <Column width={250} minWidth={250} flexGrow={1} align="right">
            <HeaderCell>จำนวนเงินงวด (บาท)</HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.amount)
              }}
            </Cell>
          </Column>
          <Column width={250} minWidth={250} flexGrow={1} align="right">
            <HeaderCell>จำนวนขอเบิก (บาท)</HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.withdrawAmount)
              }}
            </Cell>
          </Column>
          <Column width={150} align="center">
            <HeaderCell>วันที่โอนเข้าบัญชี</HeaderCell>
            <Cell dataKey="withdrawDate" />
          </Column>
        </Table>
      )}
    </>
  )
}
